import React from 'react';

/** Splits "A1 @ $75/hr" or "A2 @ $65/hr ($650/day ÷ 10h)" into styled parts */
export const RoleContextLabel: React.FC<{ text: string; roleKey?: string | number }> = ({ text, roleKey }) => {
  const parenIdx = text.indexOf(' (');
  const mainPart = parenIdx >= 0 ? text.slice(0, parenIdx) : text;
  const derivation = parenIdx >= 0 ? text.slice(parenIdx) : null;
  const atIdx = mainPart.indexOf(' @ ');
  const name = atIdx >= 0 ? mainPart.slice(0, atIdx) : mainPart;
  const rate = atIdx >= 0 ? mainPart.slice(atIdx + 3) : null;

  return (
    <span key={roleKey} className={roleKey != null ? 'motion-safe:animate-[fadeSlideIn_0.25s_ease-out]' : undefined}>
      <span className="text-primary-text font-semibold">{name}</span>
      {rate && (
        <>
          <span className="text-muted-foreground/50"> @ </span>
          <span className="text-primary-text font-semibold">{rate}</span>
        </>
      )}
      {derivation && (
        <span className="text-muted-foreground/40 ml-1">{derivation}</span>
      )}
    </span>
  );
};
